import {
  ResourceTypes,
  type ResourceGroupContent,
  type TextContent,
} from '@/data/learning-path/interfaces';

export const updateStrategy = {
  [ResourceTypes.Text]: (block: TextContent, data: Partial<TextContent>) => ({
    ...block,
    content: {
      ...block.content,
      ...(data.content || {}),
    },
  }),
  [ResourceTypes.ResourceGroup]: (
    block: ResourceGroupContent,
    data: Partial<ResourceGroupContent>
  ) => ({
    ...block,
    content: {
      ...block.content,
      ...(data.content || {}),
    },
  }),
};

export const createStrategy = {
  [ResourceTypes.Text]: (position: number): TextContent => ({
    id: crypto.randomUUID(),
    position,
    type: ResourceTypes.Text,
    content: { body: '' },
  }),
  [ResourceTypes.ResourceGroup]: (position: number): ResourceGroupContent => ({
    id: crypto.randomUUID(),
    position,
    type: ResourceTypes.ResourceGroup,
    content: { resource_groups: [] },
  }),
};
